import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import * as yup from 'yup'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import LodingButton from '../../controls/LodingButton'
import { Add } from '../../../configurations/crud/opdCentersCrud'
import Container from '../../base/Container'
import { useToast } from '../../controls/Toast/ToastService'
import { IoCheckmarkDoneCircleOutline, IoLocation } from 'react-icons/io5'
import { MdErrorOutline } from 'react-icons/md'
import Card from '../../controls/Card'
import { GetEStatusByDrUser } from '../../../configurations/enums/EStatus'
import { GetAll } from '../../../configurations/crud/stateCrud'
import * as cityCrud from '../../../configurations/crud/cityCrud'
import moment from 'moment'
import { GetEOpdDays, GetEOpdDaysName } from '../../../configurations/enums/EOpdDays'
import { IoIosArrowDropdown, IoIosArrowDropdownCircle, IoIosClose } from "react-icons/io";
import { TbBuildingHospital } from "react-icons/tb";
import { RiStickyNoteAddLine } from "react-icons/ri";
import { FaRegAddressCard } from "react-icons/fa";
import { MdOutlineLocalPhone } from "react-icons/md";
import { MdMoreTime } from "react-icons/md";
import { LiaHourglassStartSolid } from "react-icons/lia";
import { LuAlarmClock } from "react-icons/lu";
import { LuAlarmClockOff } from "react-icons/lu";
import Select from '../../controls/Select'
import { RiDropdownList } from "react-icons/ri";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { HiCalendarDays } from 'react-icons/hi2'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { GetEBool } from '../../../configurations/enums/EBool'
import { BsGenderAmbiguous } from "react-icons/bs";
import { GetEDayType } from '../../../configurations/enums/EOpdType'
import { GrMultiple } from "react-icons/gr";
import { MdOutlineViewDay } from "react-icons/md";
import { PiRowsPlusTopDuotone } from "react-icons/pi";

const schema = yup.object().shape({
    centerName: yup.string().min(3, "Center name should contains at least 3 chars.").max(200, "Center name should under 200 chars.").required("Center name is required"),
    details: yup.string().min(3, "Details should contains at least 3 chars.").max(200, "Details should under 200 chars.").required("Details is required"),
    address: yup.string().min(3, "Address should contains at least 3 chars.").max(200, "Address should under 200 chars.").required("Address is required"),
    phone: yup.string().min(10, "Phone must be 10 digits.").max(10, "Phone must be 10 digits.").required("Phone is required"),
    opdDays: yup.string().required("Days is required"),
    avgOPDTimeDeff: yup.string().required("Average time is required"),
    reserveOPDNumbersForOfline: yup.string().required("Reserve OPD Numbers For Offline is required"),
    startPuttingAppointment: yup.string()
        .test(
            'not empty',
            'Start time cant be empty',
            function (value) {
                return !!value;
            }
        )
        .test(
            "start_time_test",
            "Start time must be before end time",
            function (value) {
                const { endPuttingAppointment } = this.parent;
                return isSameOrBefore(value, endPuttingAppointment);
            }
        ).required("Start Putting Appointment is required"),
    endPuttingAppointment: yup.string().required("End Putting Appointment is required"),
    opdStartTime: yup.string()
        .test(
            'not empty',
            'Start time cant be empty',
            function (value) {
                return !!value;
            }
        )
        .test(
            "start_time_test",
            "Start time must be before end time",
            function (value) {
                const { opdEndTime } = this.parent;
                return isSameOrBefore(value, opdEndTime);
            }
        ).required("Opd Start Time is required"),
    opdEndTime: yup.string().required("Opd End Time is required"),
    cityId: yup.string().required("City is required"),
    stateId: yup.string().required("State is required"),
    status: yup.string().required("Status is required"),
    doctorStatus: yup.string().required("Doctor Status is required"),
    isRegisterOnline: yup.string().required("Is Register Online is required"),
    perDayOPDLimit: yup.string().required("Per Day OPD Limit is required"),
    opdDays: yup.string().required("Opd Days is required"),
    byDaysCount: yup.string().required("By Days Count is required"),

})
const isSameOrBefore = (startTime, endTime) => {
    return moment(startTime, 'HH:mm').isSameOrBefore(moment(endTime, 'HH:mm'));
}
export default function AddCenter() {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [lodingCrud, setLodingCrud] = useState(false);
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [stateData, setStateData] = useState([])
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    const [cityData, setCityData] = useState([]);
    const [daysTag, setDaysTag] = useState([]);
    const [daysTagData, setDaysTagData] = useState([
        { Id: "A1", Name: "Monday" },
        { Id: "A2", Name: "Tuesday" },
        { Id: "A3", Name: "Wednesday" },
        { Id: "A4", Name: "Thursday" },
        { Id: "A5", Name: "Friday" },
        { Id: "A6", Name: "Saturday" },
        { Id: "A7", Name: "Sunday" },
    ]);

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            centerName: "",
            details: "",
            address: "",
            opdDays: "",
            phone: "",
            avgOPDTimeDeff: "",
            reserveOPDNumbersForOfline: "",
            startPuttingAppointment: "",
            endPuttingAppointment: "",
            opdStartTime: "",
            opdEndTime: "",
            cityId: "",
            stateId: "",
            status: 0,
            doctorStatus: 0,
            isRegisterOnline: 1,
            perDayOPDLimit: 0,
            opdType: 0,
            byDaysCount: 0
        },
        validationSchema: schema,
        onSubmit(val) {
            addCenter(val)
        }
    })
    useEffect(() => {
        if (values.opdType == 0)
            setValues(pre => ({ ...pre, byDaysCount: 0 }))
    }, [values.opdType])
    const addCenter = (param) => {
        setLodingCrud(true)
        start()
        let mparam = {
            centerName: param.centerName,
            details: param.details,
            address: param.address,
            opdDays: param.opdDays,
            phone: param.phone,
            avgOPDTimeDeff: param.avgOPDTimeDeff,
            reserveOPDNumbersForOfline: param.reserveOPDNumbersForOfline,
            startPuttingAppointment: "2000-01-01T" + param.startPuttingAppointment + ":00",
            endPuttingAppointment: "2000-01-01T" + param.endPuttingAppointment + ":00",
            opdStartTime: "2000-01-01T" + param.opdStartTime + ":00",
            opdEndTime: "2000-01-01T" + param.opdEndTime + ":00",
            cityId: param.cityId,
            status: param.status,
            doctorStatus: param.doctorStatus,
            isRegisterOnline: param.isRegisterOnline,
            perDayOPDLimit: param.perDayOPDLimit,
            opdType: param.opdType,
            byDaysCount: param.byDaysCount
        }
        Add(mparam).then(res => {
            let mdata = res.data
            if (mdata.succeeded) {
                setValues({
                    centerName: "",
                    details: "",
                    address: "",
                    opdDays: "",
                    phone: "",
                    avgOPDTimeDeff: "",
                    reserveOPDNumbersForOfline: "",
                    startPuttingAppointment: "",
                    endPuttingAppointment: "",
                    opdStartTime: "",
                    opdEndTime: "",
                    cityId: "",
                    stateId: "",
                    status: "",
                    doctorStatus: "",
                    isRegisterOnline: "",
                    perDayOPDLimit: "",
                    opdType: "",
                    byDaysCount: ""
                })
                toast.open("OPD Center added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
            } else {
                toast.open(mdata.message, <MdErrorOutline />, "danger")
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    useEffect(() => {
        if (daysTag.length > 0) {
            let days = daysTag
            let opd = "";
            for (let i = 0; i < days.length; i++) {
                if (i == 0)
                    opd = opd + days[i]
                else
                    opd = opd + "," + days[i]
            }
            setValues({ ...values, opdDays: opd })
        }
    }, [daysTag])
    const addTags = (e) => {
        let days = daysTagData
        let removeIndex = 0;
        let opd = "";
        for (let i = 0; i < days.length; i++) {
            if (e.target.value == days[i].Id) {
                removeIndex = i;
            }
            if (i == 0)
                opd = opd + days[i].Id
            else
                opd = "," + opd + days[i].Id
        }
        days.splice(removeIndex, 1)
        setDaysTagData(days)
        let sdata = [...daysTag, e.target.value]
        sdata.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0))
        e.target.value && setDaysTag(sdata)
        e.target.value = ""
    }
    const removeTags = (item) => {
        let days = daysTag;
        let removeIndex = 0;
        for (let i = 0; i < days.length; i++) {
            if (item == days[i]) {
                removeIndex = i;
                break;
            }
        }
        days.splice(removeIndex, 1);
        setDaysTag(days);

        let opd = "";
        for (let i = 0; i < days.length; i++) {
            if (i == 0)
                opd = opd + days[i]
            else
                opd = opd + "," + days[i]
        }
        setValues({ ...values, opdDays: opd })

        let sdata = [...daysTagData, { Id: item, Name: GetEOpdDaysName(item) }]
        sdata.sort((a, b) => (a.Id > b.Id) ? 1 : ((b.Id > a.Id) ? -1 : 0))
        setDaysTagData(sdata)
    }
    useEffect(() => {
        GetStates()
    }, [])
    const GetStates = () => {
        setLodingStateCrud(true)
        start()
        GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setStateData(mdata.data)
            } else {
                setStateData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingStateCrud(false)
            end()
        }).catch(errors => {
            setStateData([])
            setLodingStateCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    useEffect(() => {
        if (stateData.length > 0 && values.stateId != "") {
            GetCities()
        }
        setValues({ ...values, cityId: "" })
    }, [values.stateId])

    const GetCities = () => {
        setLodingCityCrud(true)
        start()
        cityCrud.GetAll(values.stateId).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setCityData(mdata.data)
            } else {
                setCityData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCityCrud(false)
            end()
        }).catch(errors => {
            setCityData([])
            setLodingCityCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <Container>
            <div className='w-full lg:flex lg:flex-col lg:items-center' >
                <div className='lg:w-8/12'>
                    <Card title={"Add OPD Center"} isBack={true} isBorder={true}>
                        <form onSubmit={handleSubmit}>
                            <div class="p-6 space-y-6">
                                <div class="grid grid-cols gap-4">
                                    <div class="col-span-12">
                                        <label for="centerName" class="block mb-2 text-sm font-medium text-gray-900 ">Center Name</label>
                                        <Input placeholder="Center Name"
                                            id="centerName"
                                            Icon={< TbBuildingHospital className=' text-green-600 text-lg' />}
                                            value={values.centerName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.centerName && touched.centerName}
                                        />
                                        {errors.centerName && touched.centerName && <p className='text-red-600 text-xs'>{errors.centerName}</p>}
                                    </div>
                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="details" class="block mb-2 text-sm font-medium text-gray-900 "> Details </label>
                                        <Input placeholder="Details"
                                            id="details"
                                            Icon={<RiStickyNoteAddLine className='text-fuchsia-700 text-lg' />}
                                            value={values.details}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.details && touched.details}
                                        />
                                        {errors.details && touched.details && <p className='text-red-600 text-xs'>{errors.details}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="address" class="block mb-2 text-sm font-medium text-gray-900 "> Address</label>
                                        <Input placeholder="Address"
                                            id="address"
                                            Icon={< FaRegAddressCard className=' text-orange-700 text-lg' />}
                                            value={values.address}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.address && touched.address}
                                        />
                                        {errors.address && touched.address && <p className='text-red-600 text-xs'>{errors.address}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="opdDays" class="block mb-2 text-sm font-medium text-gray-900 "> Select days for Opd</label>
                                        <Select
                                            Icon={<HiCalendarDays className='text-cyan-500 text-lg' />}
                                            onChange={addTags}
                                            onBlur={handleBlur}>
                                            <option value="" selected>Select days...</option>
                                            {daysTagData.map((item) =>
                                                <option value={item.Id}>{item.Name}</option>
                                            )}
                                        </Select>
                                        <div class="grid grid-cols-2 sm:grid-cols-3 mt-2 gap-1 col-span-12 sm:col-span-6">
                                            {
                                                daysTag.map(item =>
                                                    <div class="flex items-end justify-between bg-gray-300 border rounded-md pl-2 pr-1 pb-1 hover:bg-gray-400">
                                                        <div className='text-sm'>{GetEOpdDaysName(item)}</div> <button onClick={() => removeTags(item)} className="pl-1 hover:text-gray-800"><IoIosClose /></button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        {errors.opdDays && <p className='text-red-600 text-xs'>{errors.opdDays}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="phone" class="block mb-2 text-sm font-medium text-gray-900 ">  Phone</label>
                                        <Input placeholder="Phone"
                                            id="phone"
                                            type="number"
                                            Icon={< MdOutlineLocalPhone className='text-blue-700 text-lg' />}
                                            value={values.phone}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.phone && touched.phone}
                                        />
                                        {errors.phone && touched.phone && <p className='text-red-600 text-xs'>{errors.phone}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="avgOPDTimeDeff" class="block mb-2 text-sm font-medium text-gray-900 "> Average time for each patient</label>
                                        <Input placeholder="Doctor will take average time for each patient"
                                            id="avgOPDTimeDeff"
                                            Icon={< MdMoreTime className='text-amber-700 text-lg' />}
                                            type="number"
                                            value={values.avgOPDTimeDeff}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.avgOPDTimeDeff && touched.avgOPDTimeDeff}
                                        />
                                        {errors.avgOPDTimeDeff && touched.avgOPDTimeDeff && <p className='text-red-600 text-xs'>{errors.avgOPDTimeDeff}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="reserveOPDNumbersForOfline" class="block mb-2 text-sm font-medium text-gray-900 "> Reserve Appoinments for Offline</label>
                                        <Input placeholder="Reserve Opd Appoinments For Offline"
                                            id="reserveOPDNumbersForOfline"
                                            Icon={< MdMoreTime className='text-indigo-700 text-lg' />}
                                            type="number"
                                            value={values.reserveOPDNumbersForOfline}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.reserveOPDNumbersForOfline && touched.reserveOPDNumbersForOfline}
                                        />
                                        {errors.reserveOPDNumbersForOfline && touched.reserveOPDNumbersForOfline && <p className='text-red-600 text-xs'>{errors.reserveOPDNumbersForOfline}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="startPuttingAppointment" class="block mb-2 text-sm font-medium text-gray-900 "> Start Putting Appointment <span className='text-xs font-normal'><br />(No use in case of by multiple days type)</span></label>
                                        <Input placeholder="Start Putting Appointment"
                                            id="startPuttingAppointment"
                                            Icon={<LiaHourglassStartSolid className='text-green-500 text-lg' />}
                                            type="time"
                                            value={values.startPuttingAppointment}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.startPuttingAppointment && touched.startPuttingAppointment}
                                        />
                                        {errors.startPuttingAppointment && touched.startPuttingAppointment && <p className='text-red-600 text-xs'>{errors.startPuttingAppointment}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="endPuttingAppointment" class="block mb-2 text-sm font-medium text-gray-900 "> End Putting Appointment <span className='text-xs font-normal'><br />(No use in case of by multiple days type)</span></label>
                                        <Input placeholder="End Putting Appointment"
                                            id="endPuttingAppointment"
                                            Icon={<LiaHourglassStartSolid className='text-red-500 text-lg' />}
                                            type="time"
                                            value={values.endPuttingAppointment}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.endPuttingAppointment && touched.endPuttingAppointment}
                                        />
                                        {errors.endPuttingAppointment && touched.endPuttingAppointment && <p className='text-red-600 text-xs'>{errors.endPuttingAppointment}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="opdStartTime" class="block mb-2 text-sm font-medium text-gray-900"> Opd Start Time</label>
                                        <Input placeholder="Opd Start Time"
                                            id="opdStartTime"
                                            Icon={<LuAlarmClock className='text-green-600' />}
                                            type="time"
                                            value={values.opdStartTime}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.opdStartTime && touched.opdStartTime}
                                        />
                                        {errors.opdStartTime && touched.opdStartTime && <p className='text-red-600 text-xs'>{errors.opdStartTime}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="opdEndTime" class="block mb-2 text-sm font-medium text-gray-900 "> Opd End Time</label>
                                        <Input placeholder="Opd End Time"
                                            id="opdEndTime"
                                            Icon={<LuAlarmClockOff className='text-red-600' />}
                                            type="time"
                                            value={values.opdEndTime}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.opdEndTime && touched.opdEndTime}
                                        />
                                        {errors.opdEndTime && touched.opdEndTime && <p className='text-red-600 text-xs'>{errors.opdEndTime}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label class="block mb-2 text-sm font-medium text-gray-900 ">State</label>
                                        {!lodingStateCrud ?
                                            <Select class="drop-down"
                                                Icon={<FaMapLocationDot className='text-green-600 text-lg' />}
                                                id="stateId"
                                                value={values.stateId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}>
                                                <option value="" selected>Select state...</option>
                                                {stateData.map((item) =>
                                                    <option value={item.id}>{item.name} ({item.shortName})</option>
                                                )}
                                            </Select>
                                            : <Select disabled class="drop-down"
                                                Icon={<FaMapLocationDot className='text-green-600 text-lg' />} >
                                                <option >Loading states...</option>
                                            </Select>
                                        }
                                        {errors.stateId && touched.stateId && <p className='text-red-600 text-xs'>{errors.stateId}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label class="block mb-2 text-sm font-medium text-gray-900">City</label>
                                        {!lodingCityCrud ?
                                            <Select class="drop-down" id="cityId"
                                                Icon={<FaLocationDot className='text-sky-600' />}
                                                value={values.cityId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}>

                                                <option value="" selected>Select city...</option>
                                                {cityData.map((item) =>
                                                    <option value={item.id}>{item.name} ({item.shortName})</option>
                                                )}
                                            </Select>
                                            : <Select disabled class="drop-down"
                                                Icon={<FaLocationDot className='text-sky-600' />} >
                                                <option >Loading cities...</option>
                                            </Select>
                                        }
                                        {errors.cityId && touched.cityId && <p className='text-red-600 text-xs'>{errors.cityId}</p>}
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="isRegisterOnline" class="block mb-2 text-sm font-medium text-gray-900 ">Register Online</label>
                                        <Select
                                            Icon={<BsGenderAmbiguous className='text-orange-600 text-lg' />}
                                            id="isRegisterOnline"
                                            value={values.isRegisterOnline}
                                            onChange={handleChange}
                                            onBlur={handleBlur}>
                                            {GetEBool.EBool.map((items, index) =>
                                                <option value={items.Id}>{items.Name}</option>
                                            )}
                                        </Select>
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="status" class="block mb-2 text-sm font-medium text-gray-900 "> Status</label>
                                        <Select class="drop-down"
                                            id="status"
                                            Icon={<IoIosArrowDropdown className='text-emerald-600 text-lg' />}
                                            value={values.status}
                                            onChange={handleChange}
                                            onBlur={handleBlur}>

                                            {GetEStatusByDrUser.EStatus.map((item) =>
                                                <option value={item.Id}>{item.Name}</option>
                                            )}
                                        </Select>
                                    </div>

                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="opdType" class="block mb-2 text-sm font-medium text-gray-900 ">OPD Type</label>
                                        <Select
                                            Icon={<MdOutlineViewDay className='text-orange-600 text-lg' />}
                                            id="opdType"
                                            value={values.opdType}
                                            onChange={handleChange}
                                            onBlur={handleBlur}>
                                            {GetEDayType.EOpdType.map((items, index) =>
                                                <option value={items.Id}>{items.Name}</option>
                                            )}
                                        </Select>
                                    </div>
                                    {values.opdType == 1 ?
                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="byDaysCount" class="block mb-2 text-sm font-medium text-gray-900 ">Days Count</label>
                                            <Input placeholder="By Days Count"
                                                id="byDaysCount"
                                                Icon={<GrMultiple className='text-red-500 text-lg' />}
                                                type="text"
                                                value={values.byDaysCount}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.byDaysCount && touched.byDaysCount}
                                            />
                                            {errors.byDaysCount && touched.byDaysCount && <p className='text-red-600 text-xs'>{errors.byDaysCount}</p>}
                                        </div>
                                        :
                                        <></>

                                    }
                                    <div class="col-span-12 sm:col-span-6">
                                        <label for="perDayOPDLimit" class="block mb-2 text-sm font-medium text-gray-900 "> Per Day OPD Limit <span className='text-xs font-normal'>(Zero for no limit)</span></label>
                                        <Input placeholder="Per Day OPD Limit"
                                            id="perDayOPDLimit"
                                            Icon={<PiRowsPlusTopDuotone className='text-red-500 text-lg' />}
                                            type="text"
                                            value={values.perDayOPDLimit}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.perDayOPDLimit && touched.perDayOPDLimit}
                                        />
                                        {errors.perDayOPDLimit && touched.perDayOPDLimit && <p className='text-red-600 text-xs'>{errors.perDayOPDLimit}</p>}
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                                {!lodingCrud ?
                                    <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                                    : <LodingButton text="Wait.." />
                                }
                            </div>
                        </form>

                    </Card>
                </div>
            </div>
        </Container >

    )
}
